/**
 * Representa la estructura de un Producto en la aplicación.
 * (En TypeScript esto sería: interfaz Producto { ... })
 */
export class PRODUCTS_LIST_DATA_API {
    constructor(data) {
        this.id = data.id || '';
        this.user = data.user || 'Anónimo';
        this.text = data.text || '';
        this.date = data.date || '';
        this.avatar = data.avatar || '👤';
        this.productId = data.productId || '';
    }
}

// Datos centralizados (como si fuera un pequeño servicio de Angular)

export const PRODUCTS_LIST_DATA_LOCAL = [
    {
        id: 1,
        user: "Laura G.",
        text: "Delicioso y súper cremoso, repetiría sin dudar.",
        date: "1 y. ago",
        avatar: "🌵",
        productId: 22123227372,
    },
    {
        id: 2,
        user: "Carlos M.",
        text: "Perfecto para compartir, porción generosa y deliciosa",
        date: "28 y. feb",
        avatar: "👤",
        productId: 127372,
    },
    {
        id: 3,
        user: "Julisn M.",
        text: "Perfecto para compartir, porción generosa y deliciosa",
        date: "28 y. feb",
        avatar: "👤",
        productId: 127372,
    }
];